module.exports = __webpack_public_path__ + "img/esma.ee84c61e.jpg";